import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

import { DefaultText } from '../../common/fontElements';

export const TicketWrapper = styled.div`
  &:focus {
    outline: none;
  }
  color: ${(props) => (props.color ? props.color : colors.baseText)};
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 50px;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? colors.blue1 : colors.inboxListBg)};
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  padding: 15px 25px 15px 25px;
  align-items: center;
  border-style: solid;
  position: relative;
  border-width: 0 0 1px 0;
  border-top-color: ${colors.lightGray21};
  border-bottom-color: ${colors.lightGray21};

  img {
    height: 25px;
    width: 25px;
  }
`;

export const MessageTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 10px 0 6px;
  justify-content: space-between;
  border-style: solid;
  border-width: 0 var(--queue-item-border-right, 0) 1px 0;
  border-bottom-color: ${colors.lightGray21};
  border-right-color: ${colors.lightGray21};
  overflow: hidden;
  position: relative;
`;

export const MessageTextLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2 1 0;
  justify-content: center;
  overflow-x: hidden;
  white-space: nowrap;
`;

export const MessageTextRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 0;
  padding-left: 5px;
  text-align: right;
  justify-content: center;
`;

export const NoMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70%;
`;

export const NoMessagesText = styled.h1`
  margin: auto;
  text-align: center;
  color: ${colors.darkGray};
  font-size: 20px;
  font-family: 'Lato-Light', sans-serif;
  padding-bottom: 100px;
`;

export const TicketText = styled(DefaultText)`
  font-family: 'Lato-Bold', sans-serif;
  white-space: nowrap;
  color: ${(props) => {
    if (props.selected) {
      return colors.whiteText;
    }

    return colors.black4;
  }};
`;

export const MessageTextOverflow = styled(TicketText)`
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${(props) => (props.selected ? colors.whiteText : colors.darkGray1)};
  font-family: 'Lato-Regular', sans-serif;
`;

export const StatusTextWrapper = styled.div`
  display: flex;
`;

export const UpsellTooltipContent = styled.div`
  padding: 10px;
  width: 175px;
  border-radius: 4px;
  background-color: ${colors.white};
`;

export const UpsellTooltipTitle = styled.div`
  color: ${colors.baseText};
  font-size: 12px;
  font-family: Roboto;
  margin-bottom: 5px;
`;

export const UpsellTooltipDescription = styled.div`
  color: ${colors.darkGray1};
  font-size: 11px;
  font-family: Roboto;
`;

export const SmallText = styled(TicketText)`
  font-size: 11px;
  color: ${(props) => (props.$selected ? colors.whiteText : colors.darkGray1)};
  font-family: 'Lato-Regular', sans-serif;
`;
